module.exports = __webpack_public_path__ + "img/dsiccc2020930.0c3db423.svg";